export default __webpack_public_path__ + "static/media/AssetMonitoring.dcc8f76b.jpg";